import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { TvRounded } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

export function EnterTVModeMenuItem() {
  const [searchParams, setSearchParams] = useSearchParams();
  const rows = useDashboardStore(({ metadata }) => metadata.layout?.rows);

  const enterTVMode = () => {
    setSearchParams({ ...searchParams, tv: 'true' });
  };

  if (!rows?.length) {
    return null;
  }

  return (
    <MenuItem onClick={enterTVMode}>
      <ListItemIcon>
        <TvRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>Enter TV Mode</ListItemText>
    </MenuItem>
  );
}
